import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "fields",
    "journalArticleFields",
    "conferencePaperFields",
    "bookFields",
    "bookChapterFields",
    "thesisFields",
    "reportFields"
  ]

  connect() {
    // On page load, if a type is already selected, set required fields
    const typeSelect = document.getElementById("publication_type_select")
    if (typeSelect && typeSelect.value) {
      this.typeChanged({ target: typeSelect })
    }
  }

  typeChanged(event) {
    const type = event.target.value
    this.hideAll()
    this.removeAllRequired()
    this.showFieldsForType(type)
  }

  showFieldsForType(type) {
    switch (type) {
      case "Publications::JournalArticle":
        this.journalArticleFieldsTarget.style.display = ""
        this.setRequiredFields("journal")
        break
      case "Publications::ConferencePaper":
        this.conferencePaperFieldsTarget.style.display = ""
        this.setRequiredFields("conference")
        break
      case "Publications::Book":
        this.bookFieldsTarget.style.display = ""
        this.setRequiredFields("book")
        break
      case "Publications::BookChapter":
        this.bookChapterFieldsTarget.style.display = ""
        this.setRequiredFields("chapter")
        break
      case "Publications::Thesis":
        this.thesisFieldsTarget.style.display = ""
        this.setRequiredFields("thesis")
        break
      case "Publications::Report":
        this.reportFieldsTarget.style.display = ""
        this.setRequiredFields("report")
        break
    }
  }

  hideAll() {
    this.journalArticleFieldsTarget.style.display = "none"
    this.conferencePaperFieldsTarget.style.display = "none"
    this.bookFieldsTarget.style.display = "none"
    this.bookChapterFieldsTarget.style.display = "none"
    this.thesisFieldsTarget.style.display = "none"
    this.reportFieldsTarget.style.display = "none"
  }

  removeAllRequired() {
    // Seleciona todos campos específicos e remove required
    document.querySelectorAll('[data-field-type]').forEach(field => {
      field.removeAttribute('required')
    })
  }

  setRequiredFields(type) {
    // Adiciona required aos campos do tipo específico
    document.querySelectorAll(`[data-field-type="${type}"][data-required="true"]`).forEach(field => {
      field.setAttribute('required', 'required')
    })
  }
}
